import { useCallback, useEffect, useRef, useState } from 'react';
import apiService from '../../services/api';

const STALE_AFTER_MS = 30000;

// A teacher's upcoming canceled classes ([{ kind, id, date, reason, movedTo }]), reloaded when the window comes
// back into focus so a cancellation made elsewhere shows up. `enabled: false` makes no request.
export default function useUpcomingCancellations(enabled = true) {
  const [cancellations, setCancellations] = useState([]);
  const loadedAt = useRef(0);

  const load = useCallback(async () => {
    try {
      const res = await apiService.getUpcomingCancellations();
      if (res?.success) setCancellations(res.cancellations || []);
      loadedAt.current = Date.now();
    } catch (error) {
      // A user without access (or an old server) just gets no notice.
    }
  }, []);

  useEffect(() => {
    if (!enabled) return undefined;
    load();
    const onFocus = () => { if (Date.now() - loadedAt.current > STALE_AFTER_MS) load(); };
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [enabled, load]);

  return cancellations;
}
